import { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { apiCall } from "services/api";
import { paramParsify } from "utils/queryParams";

export const useGetCompanyCounts = ({ enableParams = false, by } = {}) => {
  const location = useLocation();
  const queryParams = paramParsify(location?.search);

  const [response, setResponse] = useState();
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);

  const fetchData = useCallback(async () => {
    const defaultSectorId = 1;
    setLoading(true);
    try {
      const response = await apiCall({
        url: "/v1/company/count",
        queryParams: enableParams
          ? { sector_id: defaultSectorId, ...queryParams, by }
          : { by },
        method: "GET",
      });
      setResponse(response);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  }, [by, enableParams, queryParams]);

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...(enableParams ? [queryParams?.sector_id] : [])]);

  return { response, loading, error, refetch: fetchData };
};

export const useGetCompanyWatchlist = () => {
  const location = useLocation();
  const queryParams = paramParsify(location?.search);

  const [response, setResponse] = useState();
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const response = await apiCall({
        url: "/v1/company/watchlist",
        queryParams: {
          page: queryParams?.page,
          name: queryParams?.name,
          limit: 5,
        },
        method: "GET",
      });
      setResponse(response);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  }, [queryParams]);

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    // eslint-disable-next-line react-hooks/exhaustive-deps
    String(queryParams?.page),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    String(queryParams?.name),
  ]);

  return { response, loading, error, refetch: fetchData };
};

export const useGetCompanyWatchlistCriteria = () => {
  const [response, setResponse] = useState();
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const response = await apiCall({
        url: "/v1/company/watchlist-criteria",
        method: "GET",
      });
      setResponse(response);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { response, loading, error, refetch: fetchData };
};
